module.exports = __webpack_public_path__ + "img/banner-main-web-01-chi.73a60d4f.png";